import React, { ReactElement, useCallback } from 'react';
import classNames from 'classnames';
import { News as NewsComponent } from 'b2b-components/theme/components/CMS/News';
import { Pagination } from 'b2b-apps/shop/common/components/Pagination';
import { getDate } from 'b2b-apps/shop/common/utils/date/date';
import { NEWSROOM_NEWS_PAGE_SIZE } from 'b2b-apps/shop/content/redux/newsroom/sagas';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { NewsroomNewsType } from 'b2b-common/core/content/api/Newsroom.types';
import fallbackImg from './assets/news-fallback.jpg';
import { ComponentType, Props } from './';

const NewsroomNews: ComponentType = ({
  className,
  newsData,
  lang,
  onPaginationPageChange,
  onNewsButtonClick,
  page,
}: Props): ReactElement | null => {
  const t = useTranslate();
  const text = {
    readMore: t('Read more »'),
  };

  const renderPagination = useCallback(
    (newsData: NewsroomNewsType | null): ReactElement | null => {
      if (newsData) {
        return (
          <Pagination
            total={Math.ceil(newsData.total / NEWSROOM_NEWS_PAGE_SIZE)}
            page={page || 1}
            onPageChange={onPaginationPageChange}
          />
        );
      }

      return null;
    },
    [
      page,
      onPaginationPageChange,
    ],
  );

  if (!newsData || !newsData.news || !Array.isArray(newsData.news) || !newsData.news.length) {
    return null;
  }

  const rootClassName = classNames(
    'cds-cms-NewsroomNews',
    className,
  );

  return (
    <div className={rootClassName}>
      <div className="row">
        {
          newsData.news.map(news => <NewsComponent
            className="col-md-4 col-sm-6 col-xs-12"
            key={news.uid}
            onClick={onNewsButtonClick}
            publicationDate={getDate(news.publicationDate)}
            text={text}
            thumbnail={news.thumbnail || fallbackImg}
            title={news.title}
            url={`/${lang}${news.url}`}
          />)
        }
      </div>
      {renderPagination(newsData)}
    </div>
  );
};

export {
  NewsroomNews,
};
